import { AccountConfigNonStandardProperties } from "./reducers/environments";

/**
 * KEEP THESE SORTED ALPHABETICALLY.
 */
type FeatureFlag =
  | "accessibilityCompliance"
  | "adBlock"
  | "adPerformanceMeta"
  | "allowJsDynamicProp"
  | "analytics"
  | "audienceEmailFromUserProperty"
  | "audienceSegmentationUserProperties"
  | "audiences"
  | "audiencesIngest"
  | "botBlocking"
  | "cdaDashboard"
  | "chatSupport"
  | "contractAllowsAIUsage"
  | "dataConnectors"
  | "disableMasqueradeWarningBanner"
  | "displayNewEventLibraryPage"
  | "emitAppointmentAttributionEvents"
  | "emitAppointmentAttributionEventsMeta"
  | "eventIdentitySupport"
  | "eventLibraryV2"
  | "freshpaintAiChat"
  | "freshpaintAiPersonas"
  | "freshpaintConsentManagementUI"
  | "functions"
  | "googleAdsEnhancedConversionsPassthrough"
  | "heatmaps"
  | "hipaaV2"
  | "identityMatching"
  | "marketingPerformanceAnalysis"
  | "networkEventDefs"
  | "persistenceDenylist"
  | "personas"
  | "phoneNumberAudiences"
  | "podscribe"
  | "precisionEventsDefaultNotSegmentCompatible"
  | "rbac"
  | "selfServeAuditLog"
  | "serviceAccounts"
  | "sessionReplayCardViewEnabled"
  | "sessionReplayEnabled"
  | "sessionReplayRecordingPaused"
  | "sourceFunctions"
  | "sqlTransformations"
  | "sqlTransformationsv2"
  | "strictExternalIdMatching"
  | "tempSegmentsM1"
  | "tempTopConversionsChart"
  | "traces"
  | "translation"
  | "unifiedDestinationsUI"
  | "useUnifiedEntryScript"
  | "webTrackerMonitoring"
  | "webTrackerMonitoringM3"
  | "webTrackerMonitoringTrackerBlockedUI";

export type FlagGetter = (featureName: FeatureFlag) => boolean;

/**
 * Get the value of a feature flag
 */
interface FeatureFlagConfigurationLocation {
  config: Partial<
    Record<FeatureFlag, boolean> & AccountConfigNonStandardProperties
  >;
}
export function getFeature(
  accountMetadata: FeatureFlagConfigurationLocation,
  featureFlag: FeatureFlag,
): boolean {
  switch (featureFlag) {
    case "accessibilityCompliance":
    case "adBlock":
    case "adPerformanceMeta":
    case "allowJsDynamicProp":
    case "analytics":
    case "audiences":
    case "audiencesIngest":
    case "audienceEmailFromUserProperty":
    case "audienceSegmentationUserProperties":
    case "botBlocking":
    case "cdaDashboard":
    case "chatSupport":
    case "contractAllowsAIUsage":
    case "dataConnectors":
    case "disableMasqueradeWarningBanner":
    case "displayNewEventLibraryPage":
    case "emitAppointmentAttributionEvents":
    case "emitAppointmentAttributionEventsMeta":
    case "freshpaintAiChat":
    case "freshpaintAiPersonas":
    case "freshpaintConsentManagementUI":
    case "functions":
    case "googleAdsEnhancedConversionsPassthrough":
    case "heatmaps":
    case "hipaaV2":
    case "identityMatching":
    case "eventLibraryV2":
    case "marketingPerformanceAnalysis":
    case "eventIdentitySupport":
    case "networkEventDefs":
    case "persistenceDenylist":
    case "personas":
    case "phoneNumberAudiences":
    case "podscribe":
    case "precisionEventsDefaultNotSegmentCompatible":
    case "rbac":
    case "selfServeAuditLog":
    case "serviceAccounts":
    case "sessionReplayCardViewEnabled":
    case "sessionReplayEnabled":
    case "sessionReplayRecordingPaused":
    case "sourceFunctions":
    case "sqlTransformations":
    case "sqlTransformationsv2":
    case "strictExternalIdMatching":
    case "tempSegmentsM1":
    case "tempTopConversionsChart":
    case "traces":
    case "translation":
    case "unifiedDestinationsUI":
    case "useUnifiedEntryScript":
    case "webTrackerMonitoring":
    case "webTrackerMonitoringM3":
    case "webTrackerMonitoringTrackerBlockedUI":
      return accountMetadata.config[featureFlag] || false;
    default:
      console.warn("Unsupported feature %s requested", featureFlag);
      return false;
  }
}

export default FeatureFlag;
